import {
    applyMiddleware,
    combineReducers,
    createStore,
    compose
} from 'redux';
import thunk from 'redux-thunk';
import { LabelFactoryListReducer } from './reducer';

const middleware = applyMiddleware(thunk);

const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const reducers = combineReducers({
    labelFactoryList: LabelFactoryListReducer,

});

export const store = createStore(reducers, composeEnhancers(middleware));